import DetailsHeader from 'app/components/common/reports/DetailsHeader'

import { useReportAllSchoolsAllowancesAndFoodModesDto } from '../../../_common/useReportAllSchoolsAllowancesAndFoodModesDto'
import { useReportTotalsAllowancesAndFoodModesDto } from '../../../_common/useReportTotalsAllowancesAndFoodModesDto'
import { useReportAllowances } from '../../../_common/useReportAllowances'
import { ByAllowancesAndFoodModesTable } from './ByAllowancesAndFoodModesTable'


export const ByAllowancesAndFoodModes = () => {
  const allowances = useReportAllowances()
  const allSchoolsAllowancesAndFoodModesDto = useReportAllSchoolsAllowancesAndFoodModesDto()
  const totalsAllowancesAndFoodModesDto = useReportTotalsAllowancesAndFoodModesDto()

  if (!allowances || !allSchoolsAllowancesAndFoodModesDto || !totalsAllowancesAndFoodModesDto) return null

  return (
    <>
      <DetailsHeader reportTitle="Дотации" />
      <ByAllowancesAndFoodModesTable
        allowances={allowances}
        allSchoolsAllowancesAndFoodModesDto={allSchoolsAllowancesAndFoodModesDto}
        totalsAllowancesAndFoodModesDto={totalsAllowancesAndFoodModesDto}
      />
    </>
  )
}
